'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const tslib = require('tslib');
const heyListen_es = require('../../../../hey-listen/dist/hey-listen.es.js');
const mix = require('./mix.js');
require('../../../../style-value-types/dist/es/numbers/index.js');
require('../../../../style-value-types/dist/es/numbers/units.js');
const hsla = require('../../../../style-value-types/dist/es/color/hsla.js');
const rgba = require('../../../../style-value-types/dist/es/color/rgba.js');
const hex = require('../../../../style-value-types/dist/es/color/hex.js');
require('../../../../style-value-types/dist/es/color/index.js');
require('../../../../style-value-types/dist/es/complex/index.js');
require('../../../../style-value-types/dist/es/complex/filter.js');

var mixLinearColor = function (from, to, v) {
  var fromExpo = from * from;
  var toExpo = to * to;
  return Math.sqrt(Math.max(0, v * (toExpo - fromExpo) + fromExpo));
};
var colorTypes = [hex.hex, rgba.rgba, hsla.hsla];
var getColorType = function (v) {
  return colorTypes.find(function (type) {
    return type.test(v);
  });
};
var notAnimatable = function (color) {
  return "'" + color + "' is not an animatable color. Use the equivalent color code instead.";
};
var mixColor = function (from, to) {
  var fromColorType = getColorType(from);
  var toColorType = getColorType(to);
  heyListen_es.invariant(!!fromColorType, notAnimatable(from));
  heyListen_es.invariant(!!toColorType, notAnimatable(to));
  heyListen_es.invariant(fromColorType.transform === toColorType.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");
  var fromColor = fromColorType.parse(from);
  var toColor = toColorType.parse(to);
  var blended = tslib.__assign({}, fromColor);
  var mixFunc = fromColorType === hsla.hsla ? mix.mix : mixLinearColor;
  return function (v) {
    for (var key in blended) {
      if (key !== "alpha") {
        blended[key] = mixFunc(fromColor[key], toColor[key], v);
      }
    }
    blended.alpha = mix.mix(fromColor.alpha, toColor.alpha, v);
    return fromColorType.transform(blended);
  };
};

exports.mixColor = mixColor;
exports.mixLinearColor = mixLinearColor;
